/**
 * Configuración centralizada de la aplicación
 *
 * IMPORTANTE: Este archivo contiene la configuración específica de PyLC.
 * Para usar este proyecto con otra empresa, solo necesitas:
 * 1. Cambiar los valores en este archivo
 * 2. Reemplazar los assets en la carpeta correspondiente
 * 3. El resto del proyecto se adaptará automáticamente
 *
 * Este archivo contiene:
 * - Información de la empresa (PyLC específico)
 * - Colores y temas (PyLC específico) - FUENTE DE VERDAD para SCSS
 * - Logos y assets (PyLC específico)
 * - URLs y redirecciones (PyLC específico)
 * - Configuraciones generales (reutilizable)
 *
 * NOTA: Los colores definidos aquí se sincronizan automáticamente con
 * las variables SCSS a través de configHelpers.ts
 */

// ===========================================
// INFORMACIÓN DE LA EMPRESA
// ===========================================
export const companyConfig = {
  name: "Kavak",
  fullName: "Kavak",
  description: "Seguros de autos",
  tagline: "Tu seguro de confianza",
  version: "1.0.0",
  typeUserOne: "Enlace",
  typeUserOnePlural: "Enlaces",
  typeUserTwo: "Analista",
  typeUserTwoPlural: "Analistas",
  loginDescription: "A tu administrador de pólizas",

  // URLs de redirección
  urls: {
    website: "https://happi.mx/",
    support: "https://happi.mx/",
    documentation: "",
    terms: "/aviso-privacidad",
    privacy: "/aviso-privacidad",
  },

  // Información de contacto
  contact: {
    email: "",
    phone: "",
    address:
      "Blvd. Campestre #2741, Int 1. Cañada del Refugio. León, Guanajuato.",
  },
};

import ManWorkingOnLaptop from './assets/man-working-on-laptop.png';
import KavanLogo from './assets/kavak.svg';
import KavanLogoDark from './assets/kavak_dark.svg';
import KavanLogoIcon from './assets/kavak_icon_light.png';
import KavanLogoIconDark from './assets/kavak_icon_dark.png';

// ===========================================
// LOGOS Y ASSETS
// ===========================================
export const assetsConfig = {
  logos: {
    main: KavanLogo,
    main_dark: KavanLogoDark,
    icon: KavanLogoIcon,
    icon_dark: KavanLogoIconDark,
    favicon: KavanLogoIcon,

    // Logos adicionales para diferentes contextos
    theme: KavanLogo,
    dark_theme: KavanLogoDark,
    theme_rtl: KavanLogo,
    dark_theme_rtl: KavanLogoDark,
    small: KavanLogoIcon,
  },

  // Favicons y PWA
  favicons: {
    appleTouchIcon: KavanLogoIcon,
    favicon32: KavanLogoIcon,
    favicon16: KavanLogoIcon,
    manifest: KavanLogoIcon,
  },

  // Imágenes de fondo y decorativas
  images: {
    loginBackground: ManWorkingOnLaptop,
    dashboardBanner: "",
  },
};

// ===========================================
// COLORES
// ===========================================

export const colorsConfig = {
  light: {
    primary: "#1451ec",
    secondary: "#777777",
    info: "#17a2b8", // Azul turquesa más estándar para información
    success: "#28a745", // Verde estándar para éxito
    warning: "#f8c076", // Amarillo estándar para advertencias
    error: "#dc3545", // Rojo estándar para errores
    errorSecondary: "#e57373", // Rojo más suave para errores secundarios
    indigo: "#6610f2", // Un tono más vibrante para el índigo
    lightprimary: "#f8f0fa", // Fondo más claro para "primary"
    lightinfo: "#e3f8fc", // Azul claro para "info"
    lightsecondary: "#f6f6f6", // Gris claro para fondo secundario
    lightsuccess: "#e6f9ef", // Verde claro para éxito
    lighterror: "#fde2e2", // Rojo claro para error
    lightwarning: "#fff7e6", // Amarillo claro para advertencias
    lightindigo: "#efe5fd", // Índigo claro para fondos
    textPrimary: "#212529", // Texto principal en negro intenso
    textSecondary: "#495057", // Texto secundario en gris oscuro
    borderColor: "#ced4da", // Gris claro para bordes
    inputBorder: "#dee2e6", // Gris más claro para bordes de inputs
    containerBg: "#fafafa", // Fondo de contenedores en blanco
    background: "#f8f9fa", // Fondo principal en gris claro
    hoverColor: "#e9ecef", // Color para hover en elementos
    surface: "#fafafa", // Superficies como blanco
    grey100: "#adb5bd", // Gris claro para texto terciario
    grey200: "#6c757d", // Gris oscuro para detalles secundarios
    darkbg: "#343a40", // Fondo oscuro en ciertos elementos
    bglight: "#f1f3f5", // Fondo claro para contrastes
    bgdark: "#e9ecef", // Fondo oscuro para sombras
    blueBin: "#343a40", // Azul más oscuro para contraste en bin
    greenProject: "#008f39", // Verde más estándar para "Pylc"
    greenNewProject: "#00732c", // Verde más oscuro para nuevo
    greenRenovationProject: "#a2f19e", // Verde pastel para renovación
    orangeProject: "#ff8c42", // Naranja brillante
    yellowProject: "#fadb14", // Amarillo más vibrante
    pinkSecondaryProject: "#e91e63", // Rosa vibrante
    purpleComercialProject: "#6200ea", // Morado comercial vibrante
  },
  dark: {
    primary: "#1451ec",
    secondary: "#777777",
    info: "#17a2b8", // Azul turquesa más estándar para información
    success: "#28a745", // Verde estándar para éxito
    warning: "#F8B15D", // Amarillo estándar para advertencias
    error: "#dc3545", // Rojo estándar para errores
    errorSecondary: "#e57373", // Rojo más suave para errores secundarios
    indigo: "#8763DA",
    lightprimary: "#f4e9fa",
    lightinfo: "#1a3247",
    lightsecondary: "#2f3f4c",
    lightsuccess: "#102d35",
    lighterror: "#72483d",
    lightwarning: "#282b32",
    textPrimary: "#EAEFF4",
    textSecondary: "#fff",
    lightindigo: "#1d233e",
    borderColor: "#535353",
    inputBorder: "#465670",
    containerBg: "#000000",
    background: "#535353",
    hoverColor: "#333f55",
    surface: "#000000",
    grey100: "#7C8FAC",
    grey200: "#EAEFF4",
    darkbg: "#111936",
    bglight: "#16293e",
    bgdark: "#16293e",
    blueBin: "#68EF00",
    greenProject: "#0bc707",
    greenNewProject: "#078f04",
    greenRenovationProject: "#c1ff72",
    orangeProject: "#ff914d",
    yellowProject: "#ffdd4d",
    pinkSecondaryProject: "#ff004d",
    purpleComercialProject: "#5E17EB",
  },
  loginColors: {
    left: "#1451ec",
    right: "#777777",
  },
};

export const config = {
  company: companyConfig,
  assets: assetsConfig,
  colors: colorsConfig,
};

// Exportación por defecto
export default config;
